import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../styles/NewsDetail.css';

const NewsDetail = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        setLoading(true);
        const response = await fetch(`https://esportslah.gg/api/news.php?id=${id}`);

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.data) {
            setArticle(data.data);
          } else {
            setError('Article not found');
          }
        } else {
          setError('Failed to load article');
        }
      } catch (err) {
        console.error('Error fetching article:', err);
        setError('Failed to load article');
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [id]);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-MY', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const getCategoryColor = (category) => {
    const colors = {
      'Events': '#ff1a1a',
      'Pokemon': '#ffcb05',
      'One Piece': '#c41e3a',
      'Dragon Ball': '#ff6b00',
      'Digimon': '#1e90ff',
      'Guide': '#9932cc',
      'Magic': '#8b4513',
      'Esports': '#00bfff',
      'CardsLah': '#ff1a1a',
      'Cards': '#ff1a1a',
      'Updates': '#00bfff',
      'Strategy': '#9932cc'
    };
    return colors[category] || '#ff1a1a';
  };

  const formatContent = (content) => {
    if (!content) return '';
    // Convert line breaks to HTML and wrap in paragraphs
    return content
      .split(/\r?\n\r?\n/)
      .map(paragraph => `<p>${paragraph.replace(/\r?\n/g, '<br>')}</p>`)
      .join('');
  };

  if (loading) {
    return (
      <div className="news-detail-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Loading article...</p>
        </div>
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="news-detail-page">
        <div className="error-container">
          <h2>Article Not Found</h2>
          <p>{error || 'The article you are looking for does not exist.'}</p>
          <Link to="/#news" className="back-btn">
            <span className="btn-text">BACK TO NEWS</span>
            <span className="btn-burst">!</span>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="news-detail-page">
      <div className="news-detail-container">
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link to="/">Home</Link>
          <span className="separator">/</span>
          <Link to="/#news">News</Link>
          <span className="separator">/</span>
          <span className="current">{article.title}</span>
        </div>

        {/* Article Header */}
        <header className="article-header">
          <span
            className="article-category"
            style={{ background: getCategoryColor(article.category) }}
          >
            {article.category}
          </span>
          <h1 className="article-title">{article.title}</h1>
          <div className="article-meta">
            <span className="article-author">By {article.author}</span>
            <span className="meta-divider">|</span>
            <span className="article-date">{formatDate(article.created_at)}</span>
          </div>
        </header>

        {/* Featured Image */}
        {article.image && (
          <div className="article-featured-image">
            <img src={article.image} alt={article.title} />
            <div className="image-burst">EXCLUSIVE!</div>
          </div>
        )}

        {/* Article Content */}
        <article className="article-content">
          <div
            className="article-body"
            dangerouslySetInnerHTML={{ __html: formatContent(article.content || article.context) }}
          />
        </article>

        {/* Article Footer */}
        <footer className="article-footer">
          <div className="share-section">
            <span className="share-label">SHARE THIS:</span>
            <div className="share-buttons">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn facebook"
              >
                Facebook
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(article.title)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn twitter"
              >
                Twitter
              </a>
              <a
                href={`https://wa.me/?text=${encodeURIComponent(article.title + ' ' + window.location.href)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn whatsapp"
              >
                WhatsApp
              </a>
            </div>
          </div>

          <Link to="/#news" className="back-btn">
            <span className="btn-text">BACK TO NEWS</span>
            <span className="btn-burst">!</span>
          </Link>
        </footer>
      </div>

      {/* Page Decoration */}
      <div className="page-decoration">
        <div className="speed-lines left"></div>
        <div className="speed-lines right"></div>
      </div>
    </div>
  );
};

export default NewsDetail;
